import React from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import SpacingPicker from './SpacingPicker'
import ColorPicker from './ColorPicker'
import FormSelect from 'components/forms/bases/FormSelect'
import RadiusPicker from 'components/forms/RadiusPicker'
import FormLabel from 'components/labels/FormLabel'

const wrapperStyle = {
  padding: 15,
  border: '1px solid #e8e8e8',
  borderRadius: 5,
  marginBottom: 10,
  marginTop: 10,
}

const BorderForm = ({
  value,
  value: {
    borderStyle = '',
    borderColor = '',
    borderTopWidth = '',
    borderBottomWidth = '',
    borderLeftWidth = '',
    borderRightWidth = '',
    borderTopLeftRadius = '',
    borderTopRightRadius = '',
    borderBottomLeftRadius = '',
    borderBottomRightRadius = '',
  },
  onChange,
}) => (
  <div>
    <div style={wrapperStyle}>
      <FormLabel dark>Style</FormLabel>
      <FormSelect
        label="style"
        value={borderStyle}
        options={
          ['none', 'solid']
        }
        onChange={(val) => onChange(updateObject(value, { borderStyle: val }))}
      />
    </div>
    <div style={wrapperStyle}>
      <SpacingPicker
        label="Thickness( px )"
        top={borderTopWidth}
        bottom={borderBottomWidth}
        left={borderLeftWidth}
        right={borderRightWidth}
        onChange={
          (val, key) => (
            onChange(updateObject(value, { [`border${key}Width`]: val }))
          )
        }
      />
    </div>
    <div style={wrapperStyle}>
      <ColorPicker
        label="Color"
        value={borderColor}
        onChange={(val) => onChange(updateObject(value, { borderColor: val }))}
      />
    </div>
    <div style={wrapperStyle}>
      <RadiusPicker
        label="Radius (px)"
        topLeft={borderTopLeftRadius}
        topRight={borderTopRightRadius}
        bottomLeft={borderBottomLeftRadius}
        bottomRight={borderBottomRightRadius}
        onChange={
          (val, key) => (
            onChange(updateObject(value, { [`border${key}Radius`]: val }))
          )
        }
      />
    </div>
  </div>
)

BorderForm.propTypes = {}
BorderForm.defaultProps = {}

export default BorderForm



// WEBPACK FOOTER //
// ./src/components/forms/BorderForm.js